import React from 'react';
import Page from '@episerver/spa-core/Page';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import BusinessPageData from '../../../Models/Content/BusinessPageData'

export default class BusinessPage extends Page<BusinessPageData> {
  render() {
    const {
      data: {mainContentArea},
      context,
    } = this.props;

    return (
      <div className='BusinessPage'>
        <ContentArea noWrap context={context} data={mainContentArea} />
      </div>
    );
  }
}